exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-5be5ef8c] {\n  font-size: 140%;\n  font-weight: 400;\n}\n.bg-service[data-v-5be5ef8c] {\n  background-size: cover;\n  background-position: center;\n  height: 220px;\n}\n.main-content[data-v-5be5ef8c] {\n  padding-bottom: 50px;\n}\n.footer[data-v-5be5ef8c] {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n}\ndiv[data-v-5be5ef8c] ul {\n  padding-left: 1.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5be5ef8c","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/service/ServiceDetail.vue
// module id = 2352
// module chunks = 0